import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PipelineControlResult {
  message?: string | null;
  jobId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class PipelineControlService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/pipeline`;

  pause(jobId: string, reason?: string | null): Observable<PipelineControlResult> {
    return this.http.post<PipelineControlResult>(`${this.baseUrl}/${jobId}/pause`, {
      reason: reason || 'Paused from Jivu Command.'
    });
  }

  resume(jobId: string): Observable<PipelineControlResult> {
    return this.http.post<PipelineControlResult>(`${this.baseUrl}/${jobId}/resume`, {});
  }

  cancel(jobId: string, reason?: string | null): Observable<PipelineControlResult> {
    return this.http.post<PipelineControlResult>(`${this.baseUrl}/${jobId}/cancel`, {
      reason: reason || 'Cancelled from Jivu Command.'
    });
  }
}
